import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
const forYou = ['Tenés una tienda de iPhones y querés empezar a hacer anuncios.', 'Vendés iPhones pero dependés demasiado del orgánico.', 'Ya probaste agencias y sentiste que no entendían tu negocio.', 'Recibís mensajes pero pocas ventas.', 'Querés aprender a elegir qué modelos publicitar.', 'Querés usar Instagram y Meta Ads con más criterio.', 'Estás empezando en el negocio y querés aprender desde cero.'];
const notForYou = ['Querés resultados mágicos sin implementar.', 'No tenés productos para vender.', 'Buscás un curso genérico de Meta Ads.', 'Querés copiar campañas sin analizar tu negocio.', 'No estás dispuesto a mejorar tus ofertas, anuncios y atención comercial.'];
export function TargetAudience() {
  return <section className="py-20 md:py-32 bg-zinc-50" data-id="element-218">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-219">
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-220">
          {/* For You */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-3xl p-8 md:p-10 shadow-sm border border-zinc-200" data-id="element-221">
            <h2 className="text-2xl md:text-3xl font-bold text-zinc-900 mb-8" data-id="element-222">
              Este curso es para vos si…
            </h2>
            <ul className="space-y-5" data-id="element-223">
              {forYou.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-224">
                  <CheckCircle2 className="w-6 h-6 text-green-500 shrink-0" data-id="element-225" />
                  <span className="text-zinc-700 leading-relaxed" data-id="element-226">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Not For You */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-zinc-100 rounded-3xl p-8 md:p-10 border border-zinc-200" data-id="element-227">
            <h2 className="text-2xl md:text-3xl font-bold text-zinc-900 mb-8" data-id="element-228">
              Este curso no es para vos si…
            </h2>
            <ul className="space-y-5" data-id="element-229">
              {notForYou.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-230">
                  <XCircle className="w-6 h-6 text-red-500 shrink-0" data-id="element-231" />
                  <span className="text-zinc-600 leading-relaxed" data-id="element-232">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}